import React, {Component} from "react";
import UserSearch from "../../input/UserSearch.component";
import {AssignApproversCopyRow} from "./CostUnitsApproversNewRow.component";
import {connect} from "react-redux";
import {
    getCostUnitsBranches,
    saveNewCostUnitRole,
    editCostUnitRole,
    deleteCostUnitRole,
    editSkippedCostUnitRole,
    deleteSkippedCostUnitRole,
} from "../costunits.action";
import * as reduxSelectors from "../../store/application.reducers";
import okGreen from "../../../assets/okVectorGreen.svg"
import okGray from "../../../assets/okVectorGray.svg"
import { Button, ButtonType } from "components/common/Button.component";
import { FileIcon, PencilIcon, Trash2Icon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes, DropdownPosition } from "types/gaiaComponents/dropdownButton.types";

class CostUnitsApproversRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inEditMode: this.props.lastRow,
            showNewRow: false,
            costUnit: this.props.costUnit
        };

        this.deleteRole = this.deleteRole.bind(this);
        this.enterEditMode = this.enterEditMode.bind(this);
        this.exitEditMode = this.exitEditMode.bind(this);
        this.saveRow = this.saveRow.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.changeRole = this.changeRole.bind(this);
        this.changeBranch = this.changeBranch.bind(this);
        this.changeDeputy = this.changeDeputy.bind(this);
        this.changeSkip = this.changeSkip.bind(this);
        this.copyRow = this.copyRow.bind(this);
        this.hideNewRow = this.hideNewRow.bind(this);
        this.saveNewRow = this.saveNewRow.bind(this);
    }

    copyRow() {
        this.setState({showNewRow: true});
        this.props.setEditMode(true);
    }

    hideNewRow() {
        this.setState({showNewRow: false});
        this.props.setEditMode(false);
    }

    changeUser(user) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.idUser = user.value;
        newCostUnit.userNameAndEmail = user.label;
        if(newCostUnit.skip && newCostUnit.idUser) {
            newCostUnit.skip = false;
        }
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeRole(value) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.role = value.roleId;
        newCostUnit.roleName = value.name;
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeBranch(value) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.branchId = value.branchId;
        newCostUnit.branchName = value.name;
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeDeputy() {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.deputy = !this.state.costUnit.deputy;

        this.setState({
            costUnit: newCostUnit
        });
    }

    changeSkip(skip) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.skip = skip;
        if (skip) {
            newCostUnit.idUser = null;
            newCostUnit.userNameAndEmail = null;
        }

        this.setState({
            costUnit: newCostUnit
        });
    }

    deleteRole() {
        if(this.state.costUnit.skip) {
            this.props.deleteSkippedCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, this.props.costUnit.role, this.props.costUnit.branchId, this.props.nodeLevel, this.props.sort);
        } else {
            this.props.deleteCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, this.props.costUnit.role, this.props.costUnit.idUser, this.props.costUnit.branchId, this.props.nodeLevel, this.props.sort);
        }
    };

    enterEditMode() {
        this.setState({
            inEditMode: true,
            costUnit: this.props.costUnit
        });

        this.props.setEditMode(true);
    }

    exitEditMode() {
        this.setState({
            inEditMode: false
        });
        if (this.props.cancelEdit) {
            this.props.cancelEdit();
        }
        if (this.props.setEditMode)
            this.props.setEditMode(false);
    }

    saveRow() {
         if (this.props.lastRow) {
            this.props.saveNewCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, this.state.costUnit.role, this.state.costUnit.idUser, this.state.costUnit.branchId, this.state.costUnit.deputy,this.state.costUnit.skip, this.props.nodeLevel, this.props.sort);
        } else {
            if(!this.props.costUnit.idUser) {
                this.props.editSkippedCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, this.state.costUnit.role, this.state.costUnit.idUser, this.state.costUnit.branchId,  this.state.costUnit.deputy, this.state.costUnit.skip, this.props.costUnit.role, this.props.costUnit.branchId, this.props.nodeLevel, this.props.sort);
            } else {
                this.props.editCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, this.state.costUnit.role, this.state.costUnit.idUser, this.state.costUnit.branchId, this.state.costUnit.deputy, this.state.costUnit.skip, this.props.costUnit.role, this.props.costUnit.idUser, this.props.costUnit.branchId, this.props.nodeLevel, this.props.sort);
            }
        }
        this.exitEditMode();
    }

    saveNewRow(newCostUnitRole) {
        this.props.saveNewCostUnitRole(this.props.costUnit.idCompany, this.props.nodeId, newCostUnitRole.role, newCostUnitRole.idUser, newCostUnitRole.branchId, newCostUnitRole.deputy,newCostUnitRole.skip, this.props.nodeLevel, this.props.sort);
        this.hideNewRow();
    }

    render() {
        if (this.state.inEditMode) {
            let isSaveEnabled = (this.state.costUnit.role && this.state.costUnit.idUser) || this.state.costUnit.skip;

            return (
                <div className="row assign-approvers-row-edit gutters-8">
                    <div className={`${this.props.costUnitsBranches.length > 0 ? "col-md-2" : "col-md-3"} `}>
                            <DropdownSelect
                            id="cost_role"
                            type={DropdownSelectTypes.VALUE}
                            value={this.state.costUnit.roleName}
                            position={DropdownPosition.BOTTOM_RIGHT}
                            extraClasses="w-100"
                            items={this.props.costUnitTypes.map((costUnit) => {
                                return {
                                    key: costUnit.name + "-" + costUnit.dimension,
                                    text: costUnit.name,
                                    onClick: () => this.changeRole(costUnit)
                                };
                            })}
                        />
                    </div>
                    <div className={`w-100 ${this.props.costUnitsBranches.length > 0 ? "col-md-3" : "col-md-5"}`}>
                            <UserSearch className={`w-100  ${this.props.costUnitsBranches.length > 0 ? "col-md-3" : "col-md-5"}`} ref="recipientInput" propagateValue={this.changeUser}
                                    value={{
                                        label: this.state.costUnit.userNameAndEmail,
                                        value: this.state.costUnit.idUser,
                                    }}
                                    menuPlacement={"auto"}
                                    menuPosition={"fixed"}
                                    menuPortalTarget={document.body}
                                    placeholder={this.props.translate("settings.substitute.selectUser")}
                                    includeSameUser={true}
                                    translate={this.props.translate} />
                    </div>
                    {this.props.costUnitsBranches.length > 0 &&
                        <div className="col-md-3">
                            <DropdownSelect
                                id="cost_branch"
                                type={DropdownSelectTypes.VALUE}
                                value={this.state.costUnit.branchName || this.props.translate("costUnitAssignApprovers.anyBranch")}
                                position={DropdownPosition.BOTTOM_RIGHT}
                                extraClasses="w-100"
                                items={[{
                                    key: '0',
                                    text: this.props.translate("costUnitAssignApprovers.anyBranch"),
                                    onClick: () => this.changeBranch({ branchId: 0, name: this.props.translate("costUnitAssignApprovers.anyBranch") })
                                }, ...this.props.costUnitsBranches.filter((branch) => {
                                    return branch.active && !branch.deleted
                                }).map((branch) => {
                                    return {
                                        key: branch.name + "-" + branch.branchId,
                                        text: branch.name,
                                        onClick: () => this.changeBranch(branch)
                                    };
                                })]}
                            />
                        </div>
                    }
                    <div className="col-md-1">
                        <div className="column-content">
                            {this.state.costUnit.deputy ?
                                <img src={okGreen} alt={"checked"} onClick={this.changeDeputy}/> :
                                <img src={okGray} alt={"not checked"} onClick={this.changeDeputy}/>
                            }
                        </div>
                    </div>

                    <div className="col-md-1">
                        <DropdownSelect
                            id="skipCostUnit"
                            type={DropdownSelectTypes.VALUE}
                            value={this.state.costUnit.skip ? this.props.translate("costUnitAssignApprovers.yes") : this.props.translate("costUnitAssignApprovers.no")}
                            position={DropdownPosition.BOTTOM_RIGHT}
                            extraClasses="w-100"
                            items={[{
                                key: '0',
                                text: this.props.translate("costUnitAssignApprovers.yes"),
                                onClick: () => this.changeSkip(true),
                                dataCy: "__tst_CU_skipCostUnit_dropDownButton_yes"
                            }, {
                                key: '1',
                                text: this.props.translate("costUnitAssignApprovers.no"),
                                onClick: () => this.changeSkip(false),
                                dataCy: "__tst_CU_skipCostUnit_dropDownButton_no"
                            }]}
                        />
                    </div>

                    <div className="col-md-2">
                        <div className="d-flex justify-content-end gap-8 ml-8">
                            <Button type={ButtonType.SECONDARY}
                                    onClick={this.saveRow}
                                    disabled={!isSaveEnabled}
                                    text={this.props.translate("costUnitAssignApprovers.save")}
                            />
                            <Button type={ButtonType.SECONDARY}
                                    onClick={this.exitEditMode}
                                    text={this.props.translate("roles.cancel")}
                            />
                        </div>
                    </div>
                </div>
            )
        } else {
            const selectedBranch = this.props.costUnitsBranches.find((branch) => {
                return branch.branchId === this.props.costUnit.branchId;
            }) || { branchId: 0, active: true };

            if (selectedBranch.branchId === 0) {
                selectedBranch.name = this.props.translate("costUnitAssignApprovers.anyBranch");
            }
            return (
                <div className={"assign-approvers-row" + (this.props.costUnit.hasRole ? "" : " text-danger fw-bold")}>
                    <div className="row gutters-8 py-8">
                        <div className={`${this.props.costUnitsBranches.length > 0 ? "col-md-2" : "col-md-3"}`}>
                            <div className="column-content">
                                {this.props.costUnit.roleName}
                            </div>
                        </div>
                        <div
                            className={`approver ${this.props.costUnitsBranches.length > 0 ? "col-md-3" : "col-md-5"}`}>
                            <div className="column-content">
                                {this.props.costUnit.userNameAndEmail}
                            </div>
                        </div>

                        {this.props.costUnitsBranches.length > 0 &&
                            <div className="col-md-3">
                                <div
                                    title={!selectedBranch.active || selectedBranch.deleted ? this.props.translate("costUnitAssignApprovers.noBranchTooltip") : null                                         }
                                    className={`${!selectedBranch.active || selectedBranch.deleted ? 'column-content-error' : ''} column-content branch-name`}
                                >
                                    {selectedBranch.name}
                                </div>
                            </div>
                        }

                        <div className="col-md-1">
                            <div className="column-content">
                                {this.props.costUnit.deputy ?
                                    <img src={okGreen} alt={"checked"}/> :
                                    <img src={okGray} alt={"not checked"}/>
                                }
                            </div>
                        </div>
                        <div className="col-md-1">
                            <div className="column-content">
                                {this.props.costUnit.skip ? this.props.translate("costUnitAssignApprovers.yes") : this.props.translate("costUnitAssignApprovers.no")}
                            </div>
                        </div>
                        <div className={"text-right col-md-2"}>
                            <div className=" d-flex justify-content-end gap-8 ml-8">
                                <Button type={ButtonType.GHOST}
                                        iconOnly={true}
                                        icon={<PencilIcon size={ICON_SIZE.MEDIUM}/>}
                                        disabled={this.props.isEditing || !this.props.allowActions}
                                        onClick={this.enterEditMode}
                                        dataTestId = {"__tst_CU_edit"}
                                />
                                <Button type={ButtonType.GHOST}
                                        iconOnly={true}
                                        icon={<FileIcon size={ICON_SIZE.MEDIUM}/>}
                                        disabled={this.props.isEditing || !this.props.allowActions}
                                        onClick={this.copyRow}
                                        dataTestId = {"__tst_CU_copy"}
                                />
                                <Button type={ButtonType.GHOST}
                                        iconOnly={true}
                                        icon={<Trash2Icon size={ICON_SIZE.MEDIUM}/>}
                                        disabled={this.props.isEditing || !this.props.allowActions}
                                        onClick={this.deleteRole}
                                        dataTestId = {"__tst_CU_delete"}
                                />
                            </div>
                        </div>
                    </div>

                    {this.state.showNewRow &&
                        <AssignApproversCopyRow costUnit={this.props.costUnit}
                                                costUnitTypes={this.props.costUnitTypes}
                                                cancelEdit={this.hideNewRow}
                                                saveNewRow={this.saveNewRow}
                                                translate={this.props.translate}/>}
                </div>)
        }
    }
}

const mapStateToProps = function (store) {
    return {
        costUnitsBranches: reduxSelectors.getCostUnitBranches(store),
    }
};

export const AssignApproversRow = connect(mapStateToProps, {
    getCostUnitsBranches,
    editCostUnitRole,
    saveNewCostUnitRole,
    deleteCostUnitRole,
    editSkippedCostUnitRole,
    deleteSkippedCostUnitRole,
})(CostUnitsApproversRow);

